import constants from 'common/constants'

import {REDUX_SET_CUSTOM_TITLES} from '../General/ActionTypes/ReduxActionTypes'
import {LOAD_FORM_DATA, LOAD_MAPPINGS, UPDATE_FORM_DATA} from './ActionTypes/ApiActionTypes'

export const loadFormData = (onSuccess, onFailure) => {
  return {
    type: LOAD_FORM_DATA,
    payload: {
      apiUrl: constants.api_load_custom_names_data,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateNames = (data, onSuccess, onFailure) => {
  return {
    type: UPDATE_FORM_DATA,
    payload: {
      apiUrl: constants.api_update_custom_names_data,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getMappings = (onSuccess, onFailure) => {
  return {
    type: LOAD_MAPPINGS,
    payload: {
      apiUrl: constants.api_load_custom_names_mappings,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: [],
      reduxActionType: REDUX_SET_CUSTOM_TITLES,
      onSuccess,
      onFailure,
    },
  }
}
